import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroupText,
  InputGroupAddon,
  InputGroup,
  FormGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import PropTypes from 'prop-types';

import { AxiosAPI, getGroupID } from '../../helpers/AxiosAPI';
import IntlMessages from '../../helpers/IntlMessages';
import {
  gAPI_QuickReply_ById,
  gAPI_QuestionOptionList,
} from '../../constants/APIs';

import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

function MessageTemplateForm({
  visible,
  toggle,
  formLabel,
  submit,
  updatemessageData,
  id,
  propertyId,
  locale,
}) {
  const [isActive, setisActive] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [messageData, setmessageData] = useState(
    updatemessageData || {
      groupId: getGroupID(),
      propertyId: propertyId,
      name: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      message: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      creator: 'api',
    }
  );
  useEffect(() => {
    if (id !== undefined) {
      setisActive(true);
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_QuickReply_ById}/${id}`,
      })
        .then((res) => {
          setmessageData(res.data);
        })
        .catch((err) => console.log('err', err));
    }
  }, [id]);

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    }
  };
  const handleChangeNameArr = (e) => {
    if (messageData.name.length > 0) {
      const index = messageData.name.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setmessageData({
          ...messageData,
          name: [...messageData.name, newStatement],
        });
      } else {
        let newArr = [...messageData.name];
        newArr[index].statement = e.target.value;
        setmessageData({
          ...messageData,
          name: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setmessageData({
        ...messageData,
        name: [...messageData.name, newStatement],
      });
    }
  };

  const handleChangeIntroductionArr = (e) => {
    if (messageData.message.length > 0) {
      const index = messageData.message.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setmessageData({
          ...messageData,
          message: [...messageData.message, newStatement],
        });
      } else {
        let newArr = [...messageData.message];
        newArr[index].statement = e.target.value;
        setmessageData({
          ...messageData,
          message: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setmessageData({
        ...messageData,
        message: [...messageData.message, newStatement],
      });
    }
  };

  const handleSubmit = () => {
    submit(messageData);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Row>
                <Colxx sm={12} className="mb-3">
                  <Label>Name</Label>
                  <Input
                    type="text"
                    value={getLocalStatement(messageData.name)}
                    onChange={handleChangeNameArr}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Message</Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(messageData.message)}
                    onChange={handleChangeIntroductionArr}
                    name="message"
                    style={{ height: '50px' }}
                  />
                </Colxx>
              </Row>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            <IntlMessages id='dashboards.save' />
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(MessageTemplateForm));
